import axios from 'axios'
import { AuthStore } from 'frontendcommon-3'
import URLS from './urls'
import { AbstractAuth } from '@/dashboards/common'
import * as Sentry from '@sentry/vue'

let SHELL_CONFIG_DATA
const sentryEnv = process.env.VUE_APP_SENTRY_ENV

export default class Auth extends AbstractAuth {
  redirectLogin ({ domain } = { domain: '' }) {
    const event = new CustomEvent('hide-content')
    window.dispatchEvent(event)
    let url = URLS.LOGIN_URL
    if (domain) {
      url = url + '?domain=' + domain
    }
    window.location.assign(url)
  }

  async redirectLogout (detail) {
    const event = new CustomEvent('hide-content')
    window.dispatchEvent(event)
    const domain = detail?.domain
    try {
      await axios.post(URLS.LOGOUT_URL)
    } catch {
      console.log('error logout')
    } finally {
      this.redirectLogin({ domain })
    }
  }

  async fetchUserInfo (accessToken) {
    try {
      const query = 'query { users_me { first_name last_name email role { id name } organization_uuid { id organization_username lab_id { id } } } }'
      const { data } = await axios.post(URLS.GATEWAY_BASE_URL + '/graphql/system', { query }, { withCredentials: true })
      return data.data.users_me
    } catch (error) {
      console.log(error)
      // this.redirectLogin()
    }
  }

  async checkSession () {
    try {
      const { data } = await axios.get(URLS.GATEWAY_BASE_URL + URLS.CHECK_SESSION_URL, { withCredentials: true })
      return data
    } catch {
      return {}
    }
  }

  async fetchShellConfig () {
    try {
      SHELL_CONFIG_DATA = SHELL_CONFIG_DATA || (await axios.create().get(URLS.SHELL_CONFIG_URL)).data
      const sidebarItem = SHELL_CONFIG_DATA.sidebar.find((item) => item.id === 'contents-of-month')
      if (sidebarItem) {
        const collection = await this.getDynamicCollection()
        if (collection) sidebarItem.url = '/repofarma/contents/filters?campaigns=' + collection.id
      }
      return await this.mergeLocalConfig(SHELL_CONFIG_DATA)
    } catch (error) {
      return { micros: [], sidebar: [] }
    }
  }

  async getDynamicCollection () {
    try {
      const response = await axios.create().post(URLS.GATEWAY_BASE_URL + '/graphql', {
        query: `
          query {
            data: collections(
              filter: {
                _and: [
                  { status: { _eq: "published" } }
                  { public: { _eq: true } }
                  { monthly_featured: { _eq: true } }
                ]
              }
              limit: -1
              sort: [ "sort" ]
            ) {
              id
            }
          }`
      }, { withCredentials: true })
      return response.data.data.data[0]
    } catch (error) {
      console.error(error)
      return null
    }
  }

  async getAuthData () {
    try {
      const session = await this.checkSession()
      if (!session.farmacloud_jti) throw new Error('Unauthorized')

      const { micros, sidebar } = await this.fetchShellConfig()
      const userData = await this.fetchUserInfo()

      const lab = (userData.organization_uuid?.lab_id) || []
      const labId = lab[0] && lab[0].id
      const userType = [userData.role?.name, labId].filter(Boolean).join('-')
      const authData = {
        isLogged: true,
        tokens: {
          farmacloud: {
            jti: session.farmacloud_jti
          }
        },
        user: {
          ...userData,
          is_admin: false,
          role: userType,
          language: 'es',
          name: userData.first_name,
          permissions: []
        },
        micros,
        sidebar
      }

      AuthStore.storeUserData(authData.user)
      this.initExternalTools(authData)
      return authData
    } catch (error) {
      console.error(error)
      this.redirectLogin()
      throw error
    }
  }

  getAllowedNavItems (items) {
    return items
  }

  onTokenUnauthorized () {
    this.redirectLogin()
  }

  onForbiddenRequest () {
    this.redirectLogin()
  }

  initExternalTools (authData) {
    this.initSentry(authData)
  }

  initSentry (authData) {
    if (sentryEnv) {
      Sentry.setUser({
        name: authData.user.name,
        language: authData.user.language,
        role: authData.user.role,
        organization_uuid: authData.user.organization_uuid
      })
    }
  }
}
